// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SearchForSecondaryCipNumbersHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryCipNumberDTO from '../models/SecondaryCipNumberDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    searchString: string | null;
    academicYear: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            searchString: "",
            academicYear: 0,
        },
        initValues);
    },
    searchString: 'searchString',
    academicYear: 'academicYear',
}

interface Result extends ResultDTO {
    cipNumbers: SecondaryCipNumberDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            cipNumbers: [],
        },
        initValues);
    },
    cipNumbers: 'cipNumbers',
}

export { Request, Result };